import ImageSlider from "../image-slider/image-slider";
import Imdb from "../case-studies/imdb";
import MarketingPage from "../marketing-page";
import "./about-us.scss";

const AboutUs = () => {

    const images = [
        {
            original: "/images/about-us/_1188369.jpg",
            width: 450,
            alt: "David Gregory setting up his camera on set"
        },
        {
            original: "/images/about-us/dave 1.jpg",
            width: 450,
            alt: "David Gregory filming on a gimbal on a set filled with smoke with green lighting"
        },
        {
            original: "/images/about-us/DSC_0288.png",
            width: 200,
            alt: "David Gregory filming on a plane"
        },
        {
            original: "/images/about-us/DSC_0495.jpg",
            width: 449,
            alt: "David Gregory filming preparing for a take in freezing conditions"
        },
        {
            original: "/images/about-us/Haywire - Gunslingers 122 cropped.png",
            width: 450,
            alt: "David Gregory relaxing between takes on a set while being a 1st AC and sound recordist at the same time"
        },
    ];
    return (
        <MarketingPage>
            <h1 className="">
                About Filmanize
            </h1>
            <div className="columns">
                <div className="column is-one-third"><img className="about-us-image" src="/images/about-us/Me.jpg" alt="David Gregory focus pulling"></img>
                    <div className="mt-1">
                        <Imdb name="David Gregory" link="https://www.imdb.com/name/nm10016507" />
                    </div></div>
                <div className="column"><p className="case-study-intro">Filmanize is the brainchild of our founder and CTO, David, a seasoned software developer with over 25 years of experience with a passion for filmmaking.  A keen filmmaker for over 12 years, he's worked on around 50 films, from small ones shot in an evening to features, from local film club projects to commercial shoots. His roles have varied from camera op, 1st AC to location sound (sometimes at the same time). He's particularly interested in the technical side of filmmaking; camera, sound and lighting through to editing and VFX.</p>
                    <p>The idea for Filmanize was conceived in early 2018 when he was on the way to a low budget shoot, where he was to be a camera operator. The writer/director gave him a call sheet created in Excel and, as a software developer David thought:
                        <div className="marketting-quote">    "Wouldn't it be easier if that was automatically generated, with data pulled in automatically?". </div>
                        From that initial idea the concept of Filmanize grew.</p>
                    <p>After a period of consultation and planning, development started in late 2019. After a few iterations the current version was created in 2021 and we have been building and improving it ever since.</p>
                    <p>Filmanize uses some of the fastest technologies to ensure it is fast, reliable, and readily accessible. This means that even in the most pressing moments on set, you can quickly access the information you need.</p>
                    <p>As Filmanize was built by filmmakers for filmmakers, our aim is to help users achieve exactly what they need. We want to make sure that it fulfils the needs of all levels of indie filmmaker, whether that's a seasoned 1st AD or a first-time writer/director. We value and welcome all feedback, as it helps us to create a tool that truly serves the needs of its users. In addition, we are a self-funded company - so we never need to prioritise investors or shareholders ahead of our users.</p>

                </div>
            </div>
            <div className="image-container">
                <ImageSlider images={images} />
            </div>
        </MarketingPage>
    );
}

export default AboutUs;